export const types = {
  GET_BLOCKED_ATTENDEES: {
    STARTED: 'GET_BLOCKED_ATTENDEES.STARTED',
    SUCCESS: 'GET_BLOCKED_ATTENDEES.SUCCESS',
    FAILURE: 'GET_BLOCKED_ATTENDEES.FAILURE',
  },
  UNBLOCK_ATTENDEE: {
    STARTED: 'UNBLOCK_ATTENDEE.STARTED',
    SUCCESS: 'UNBLOCK_ATTENDEE.SUCCESS',
    FAILURE: 'UNBLOCK_ATTENDEE.FAILURE',
  },
};

export const getBlockedAttendees = () => ({
  type: types.GET_BLOCKED_ATTENDEES.STARTED,
});

export const unblockAttendee = (id) => ({
  type: types.UNBLOCK_ATTENDEE.STARTED,
  id,
});



// WEBPACK FOOTER //
// ./redux/actions/blockedAttendees.js